import clsx from 'clsx';
import { useMemo } from 'react';
import useDOMPurify from '../../common/hooks/use-dom-purify';
import InnerHTMLDiv from '../common/inner-html-div.component';
import type { DynamicFieldComponentProps } from '../dynamic-form/dynamic-form.interfaces';
import ErrorLabel from './error-label';
import FieldLabel from './field-label';

export default function DataLabel({ label, value, error, labelStyles }: DynamicFieldComponentProps<string>) {
  const { sanitize } = useDOMPurify();
  const sanitizedValue = useMemo(() => sanitize(value ?? ''), [value, sanitize]);

  const valueStyles = clsx('text-sm [&_a]:underline [&_a]:text-url');

  return (
    <>
      {label && <FieldLabel label={label} labelStyles={labelStyles} />}
      {value && <InnerHTMLDiv className={valueStyles} html={sanitizedValue} />}
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </>
  );
}
